import React, { useContext, useRef, useEffect } from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import HeightSharpIcon from "@material-ui/icons/HeightSharp";
import MenuList from "@material-ui/core/MenuList";
import "../components/sidebar.css";
import JSCookie from "js-cookie";
import fit_to_width_icon from "../assets/icons/fit_to_width.png";
import { makeStyles } from "@material-ui/core/styles";
import { Columns, Home, Maximize, Monitor, BookOpen } from "react-feather";
//context
import { AppContext } from "../contexts/AppContext";
import { Redirect, Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import publication_img from "../assets/icons/pubiconmob.png";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "22px",
    justifyContent: "center",
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  MenuList: {
    marginTop: "19px",
  },
  MenuItem: {
    fontSize: "13px",
    fontWeight: "500",
  },
}));

export default function ToggleMenuPubLication(props) {
  const classes = useStyles();
  // global state
  const {
    setIsFitToHeight,
    isPopularDrawerOpen,
    setWidth,
    refactorHighlight,
    vw,
    setFit2page,
    setIsPopularDrawerOpen,
    ratioMainPage,
    initialPublication,
    initialEdition,
    publicationsData,
    setLogoAndTheme,
    handlePublication,
  } = useContext(AppContext);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const onFitToHeight = () => {
    setIsFitToHeight((currState) => currState + 1);

    setWidth((currState) => {
      const targetHeight = window.innerHeight - 200;

      const newWidth = ratioMainPage * targetHeight;
      refactorHighlight(newWidth, currState);
      return newWidth;
    });
    setFit2page(false);
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <div className={classes.root}>
      <div>
        <Tooltip title="Publications">
          <BookOpen
            className=" feather-29"
            ref={anchorRef}
            aria-controls={open ? "menu-list-grow" : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
          />
        </Tooltip>
        <Popper
          open={props.open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
                backgroundColor: "#f5f5f5",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={props.handleClose}>
                  <MenuList
                    className={classes.MenuList}
                    autoFocusItem={props.open}
                    id="menu-list-grow"
                    onKeyDown={handleListKeyDown}
                  >
                    {publicationsData &&
                      publicationsData.length > 0 &&
                      publicationsData.map((publication, index) => {
                        if (
                          publication.publicationcode !==
                          initialPublication?.publicationcode
                        )
                          return (
                            <MenuItem
                              key={publication.publicationcode + index}
                              onClick={async () => {
                                await JSCookie.remove("fromArchive");
                                setLogoAndTheme(
                                  publication.theme_color,
                                  publication.logo
                                );
                                handlePublication(publication, index);
                                window.location.assign(
                                  `${
                                    window.location.origin
                                  }/${publication?.publicationname
                                    ?.split(" ")
                                    .join("-")
                                    .toLowerCase()}/${publication?.editions[0]?.editionname
                                    ?.split(" ")
                                    .join("-")
                                    .toLowerCase()}`
                                );
                              }}
                              className={classes.MenuItem}
                            >
                              <Link
                                // to={`/${publication?.publicationname
                                //   ?.split(" ")
                                //   .join("-")
                                //   .toLowerCase()}/${publication?.editions[0]?.editionname
                                //   ?.split(" ")
                                //   .join("-")
                                //   .toLowerCase()}`}
                                // target="_self"
                                style={{ color: "inherit" }}
                              >
                                <p className="menu-name">
                                  {publication.publicationname}
                                </p>
                              </Link>
                            </MenuItem>
                          );
                      })}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  );
}
